export const DEFAULT_SYNC_FREQUENCY_VALUE = 3600000;
export const SYNC_FREQUENCY = [0.5, 1, 6, 8, 12, 24];
